import { ActionTypes } from './constants';
import * as Models from './models';

export const exportPackage: Models.ActionCreator.Export = (exportType, debugFlag) => ({
  type: ActionTypes.EXPORT,
  payload: {
    exportType,
    debugFlag,
  },
});
